import { LobbyStaffStatusState } from './../lobby-staff-status.state';
import { initialState } from "../lobby-staff-status.state";
import { Action, createReducer, on } from '@ngrx/store';
import * as LobbyStaffStatusActions from '../actions/lobby-staff-status.actions';
import * as MessageHubActions from 'src/app/state/actions/message-hub.actions';

const reducer = createReducer<LobbyStaffStatusState>(
    initialState,
    on(LobbyStaffStatusActions.recievedLobbyGridData, (state, action): LobbyStaffStatusState => (
        {
            ...state,
            lobbyGridData: action.gridData
        }
    )),
    on(MessageHubActions.receivedLobbyStatusGridData, (state,action): LobbyStaffStatusState => ({
        ...state,
        lobbyGridData: action?.messageData ? JSON.parse(action.messageData) : {}
    })),
    on(MessageHubActions.receivedSignalRStaffStatusGridData, (state,action): LobbyStaffStatusState => ({
        ...state,
        lobbyStaffGridData: action?.messageData ? JSON.parse(action.messageData) : {}
    })),
    on(LobbyStaffStatusActions.updateImpersonateUsers, (state,action): LobbyStaffStatusState => ({
        ...state,
        impersonateUserDetails: action?.imperSonateUserDetailinfo,
        PromptImpersonatePopup:action?.showPopUp
    })),
    on(LobbyStaffStatusActions.loadImpersonateUsers, (state,action): LobbyStaffStatusState => ({
        ...state,
        impersonateUserDetails: null
    })),
    on(LobbyStaffStatusActions.promptImpersonatePopup, (state,action): LobbyStaffStatusState => ({
        ...state,
        PromptImpersonatePopup: action?.open
    })),
    on(LobbyStaffStatusActions.updateImpersonatAssistDetails, (state,action): LobbyStaffStatusState => ({
        ...state,
        impersonateAssistDetails: action?.imperSonateAssistDetailinfo
    })),
);

export function lobbyStaffStatusReducer(state: LobbyStaffStatusState | undefined, action: Action) {
    return reducer(state, action);
}
